/**
 * Get % match (MFC Domain Logic) for Recommendations
 * @param recommendation mfc recommendation api result score
 */
export function getRecommendationPercentage(recommendation: number) {
    if (recommendation > 0.12) {
        return 100
    } else if (recommendation > 0.1) {
        return 90
    } else if (recommendation > 0.08) {
        return 80
    } else if (recommendation > 0.06) {
        return 70
    } else if (recommendation > 0.05) {
        return 60
    } else if (recommendation > 0.04) {
        return 50
    } else if (recommendation > 0.03) {
        return 40
    } else if (recommendation > 0.02) {
        return 30
    } else if (recommendation > 0.01) {
        return 20
    } else {
        return 10
    }
}
